// extracted by mini-css-extract-plugin
module.exports = {"date":"Date_date__dLQQC","text":"Date_text__2DLsl"};